module.exports = __webpack_public_path__ + "static/media/DC_F_Fashion_Roseto Sand.8453cf4a.png";